"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Sentry = __importStar(require("@sentry/react"));
const semantic_ui_react_1 = require("semantic-ui-react");
const react_redux_1 = require("react-redux");
const MapmakerButton_1 = __importDefault(require("../../shared/buttons/MapmakerButton"));
const MapmakerApi_1 = require("../../../client/MapmakerApi");
const client_1 = require("@apollo/client");
(0, client_1.gql) `
  mutation createRectangularPrintsForDownload(
    $input: CreateRectangularPrintsRequest
  ) {
    createRectangularPrints(input: $input) {
      prints {
        key
        url
      }
    }
  }
`;
function ImageDownloadButton({ printLayouts, label = "Download", }) {
    //const [createPrints, { loading, error }] = useMutation(CREATE_PRINTS);
    const [createPrints, { loading, error }] = (0, MapmakerApi_1.useCreateRectangularPrintsForDownloadMutation)();
    const { file, printOptions, downloadOptions } = (0, react_redux_1.useSelector)((state) => ({
        file: state.file,
        printOptions: state.printOptions,
        downloadOptions: state.downloadOptions,
    }));
    const onClick = () => __awaiter(this, void 0, void 0, function* () {
        const input = {
            fileId: file.id,
            format: downloadOptions.format,
            dpi: 300,
            printOptions,
            printLayouts,
        };
        try {
            const result = yield createPrints({
                variables: {
                    input,
                },
            });
            const response = result.data
                .createRectangularPrints;
            response.prints.forEach((print, i) => downloadResult(print.url));
        }
        catch (e) {
            // Error will be caught by apollo hook, but we do want to record it.
            Sentry.captureException(e);
        }
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(MapmakerButton_1.default, Object.assign({ color: "accent", size: "small", loading: loading, onClick: onClick }, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Icon, { name: "download" }), label] })), error ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "error" }, { children: "Error downloading image, please try again." }))) : null] }));
}
exports.default = ImageDownloadButton;
function downloadResult(url) {
    // Opens the image link which triggers the browser to download the image
    // Note: Safari doesn't respect the content-disposition header when opening a URL and
    // opens it up right in the webpage.  Users then need to either drag-drop it to their
    // file system or use a 3rd party app.  A better solution would be to make a page to
    // display the photo without leaving the website and show instructions there.
    window.location = url;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW1hZ2VEb3dubG9hZEJ1dHRvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3ByaW50aW5nL290aGVyL0ltYWdlRG93bmxvYWRCdXR0b24udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsc0RBQXdDO0FBRXhDLHlEQUF3RDtBQUt4RCw2Q0FBMEM7QUFFMUMseUZBQWlFO0FBQ2pFLDZEQUE0RjtBQUM1RiwyQ0FBcUM7QUFFckMsSUFBQSxZQUFHLEVBQUE7Ozs7Ozs7Ozs7O0NBV0YsQ0FBQztBQU9GLFNBQXdCLG1CQUFtQixDQUFDLEVBQzFDLFlBQVksRUFDWixLQUFLLEdBQUcsVUFBVSxHQUNPO0lBQ3pCLHdFQUF3RTtJQUN4RSxNQUFNLENBQUMsWUFBWSxFQUFFLEVBQUUsT0FBTyxFQUFFLEtBQUssRUFBRSxDQUFDLEdBQ3RDLElBQUEsMkRBQTZDLEdBQUUsQ0FBQztJQUNsRCxNQUFNLEVBQUUsSUFBSSxFQUFFLFlBQVksRUFBRSxlQUFlLEVBQUUsR0FBRyxJQUFBLHlCQUFXLEVBQ3pELENBQUMsS0FBMEIsRUFBRSxFQUFFLENBQUMsQ0FBQztRQUMvQixJQUFJLEVBQUUsS0FBSyxDQUFDLElBQUk7UUFDaEIsWUFBWSxFQUFFLEtBQUssQ0FBQyxZQUFZO1FBQ2hDLGVBQWUsRUFBRSxLQUFLLENBQUMsZUFBZTtLQUN2QyxDQUFDLENBQ0gsQ0FBQztJQUVGLE1BQU0sT0FBTyxHQUFHLEdBQVMsRUFBRTtRQUN6QixNQUFNLEtBQUssR0FBbUM7WUFDNUMsTUFBTSxFQUFFLElBQUksQ0FBQyxFQUFFO1lBQ2YsTUFBTSxFQUFFLGVBQWUsQ0FBQyxNQUFNO1lBQzlCLEdBQUcsRUFBRSxHQUFHO1lBQ1IsWUFBWTtZQUNaLFlBQVk7U0FDYixDQUFDO1FBQ0YsSUFBSTtZQUNGLE1BQU0sTUFBTSxHQUFHLE1BQU0sWUFBWSxDQUFDO2dCQUNoQyxTQUFTLEVBQUU7b0JBQ1QsS0FBSztpQkFDTjthQUNGLENBQUMsQ0FBQztZQUNILE1BQU0sUUFBUSxHQUFHLE1BQU0sQ0FBQyxJQUFJO2lCQUN6Qix1QkFBMEQsQ0FBQztZQUM5RCxRQUFRLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxDQUFDLEtBQUssRUFBRSxDQUFDLEVBQUUsRUFBRSxDQUFDLGNBQWMsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQztTQUNsRTtRQUFDLE9BQU8sQ0FBQyxFQUFFO1lBQ1Ysb0VBQW9FO1lBQ3BFLE1BQU0sQ0FBQyxnQkFBZ0IsQ0FBQyxDQUFDLENBQUMsQ0FBQztTQUM1QjtJQUNILENBQUMsQ0FBQSxDQUFDO0lBRUYsT0FBTyxDQUNMLDZEQUNFLHdCQUFDLHdCQUFjLGtCQUNiLEtBQUssRUFBQyxRQUFRLEVBQ2QsSUFBSSxFQUFDLE9BQU8sRUFDWixPQUFPLEVBQUUsT0FBTyxFQUNoQixPQUFPLEVBQUUsT0FBTyxpQkFFaEIsdUJBQUMsd0JBQUksSUFBQyxJQUFJLEVBQUMsVUFBVSxHQUFHLEVBQ3ZCLEtBQUssS0FDUyxFQUNoQixLQUFLLENBQUMsQ0FBQyxDQUFDLENBQ1AsOENBQUssU0FBUyxFQUFDLE9BQU8sZ0VBQWlELENBQ3hFLENBQUMsQ0FBQyxDQUFDLElBQUksSUFDUCxDQUNKLENBQUM7QUFDSixDQUFDO0FBdERELHNDQXNEQztBQUVELFNBQVMsY0FBYyxDQUFDLEdBQUc7SUFDekIsd0VBQXdFO0lBQ3hFLHFGQUFxRjtJQUNyRixxRkFBcUY7SUFDckYsb0ZBQW9GO0lBQ3BGLDZFQUE2RTtJQUM3RSxNQUFNLENBQUMsUUFBUSxHQUFHLEdBQUcsQ0FBQztBQUN4QixDQUFDIn0=